import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_PROGRESS } from '@/modules/progress/router';
import { progressService } from '@/services/progress';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useProgressLevelEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        progressId: route.params.progressId,
        level: route.params.level,
        name: '',
        image: null,
        imageStatus: null,
        imageFile: null
    });

    const validations = {
        name: { required },
        imageFile: {}
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => progressService.level.get(model.progressId, model.level),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_PROGRESS.LEVEL.INDEX, params: { progressId: model.progressId } })
    });

    const update = crudAction.excuteAndNotify({
        validator: v$,
        request: () => progressService.level.update(model.progressId, model.level, model.name, model.imageFile),
        onSuccess: () =>
            router.push({ name: ROUTE_NAME_PROGRESS.LEVEL.INDEX, params: { progressId: model.progressId } })
    });

    return { model, v$, update, fetch };
}
